import { ArrowLeft, ClipboardList, FileText, Settings2 } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import { getRegularTask } from "@/pages/regularTasks";
import AgreementTaskCreateForm from "@/pages/AgreementTaskCreateForm";

export default function RegularTaskDetail() {
  const { taskId } = useParams();
  const task = getRegularTask(taskId);

  if (!task) {
    return (
      <div className="acct-wrap regular-task-page" data-testid="task-reguler-not-found">
        <div className="error-banner">Task Reguler tidak ditemukan.</div>
        <Link className="regular-task-back" to="/kipk/manajemen-task/reguler" data-testid="task-reguler-not-found-back">
          <ArrowLeft size={15} /> Kembali ke Daftar Task Reguler
        </Link>
      </div>
    );
  }

  return (
    <div className="acct-wrap regular-task-page" data-testid={`task-reguler-detail-${task.id}`}>
      <div className="regular-task-detail-nav">
        <Link className="regular-task-back" to="/kipk/manajemen-task/reguler" data-testid="task-reguler-detail-back-list">
          <ArrowLeft size={15} /> Daftar Task Reguler
        </Link>
        <Link className="regular-task-management-link" to="/kipk/manajemen-task" data-testid="task-reguler-detail-back-management">
          Ke Manajemen Task
        </Link>
      </div>

      <header className="regular-task-detail-header">
        <span className="regular-task-detail-index">{String(task.order).padStart(2, "0")}</span>
        <div>
          <div className="eyebrow"><ClipboardList size={12} /> DETAIL TASK REGULER</div>
          <h2 data-testid="task-reguler-detail-title">{task.title}</h2>
        </div>
      </header>

      {task.id === "perjanjian-kerjasama" ? <AgreementTaskCreateForm /> : <section className="regular-task-placeholder" data-testid="task-reguler-placeholder">
        <div className="regular-task-placeholder-mark"><Settings2 size={24} /></div>
        <div>
          <span>HALAMAN DETAIL</span>
          <h3>Detail task belum dikonfigurasi</h3>
          <p>Area ini disiapkan untuk pengisian detail Task Reguler pada pengembangan berikutnya.</p>
        </div>
        <FileText className="regular-task-placeholder-file" size={44} aria-hidden="true" />
      </section>}
    </div>
  );
}